/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { naturalSort } from '.';
import { SurveyType } from '../types/survey';
import { ScopeQuestionOptionalValue } from '../types/surveyScope';


interface SurveyEffectiveDate {
  effectiveDate: string
  created?: string;
  type?: SurveyType;
}

export const sortSurveysDesc = (a: SurveyEffectiveDate, b: SurveyEffectiveDate) => {
  if (a.effectiveDate < b.effectiveDate) {
    return 1;
  }

  if (a.effectiveDate > b.effectiveDate) {
    return -1;
  }

  // Fallback to created
   if (a.created && b.created) {
     if (a.created < b.created) {
       return 1;
     }

     if (a.created > b.created) {
       return -1;
     }
   }

  // Fallback to created
  if (a.type && b.type) {
    if (a.type === 'aggregation' && b.type === 'default') {
      return -1;
    }

    if (a.type === 'default' && b.type === 'aggregation') {
      return 1;
    }
  }

  return 0
}

export const sortEffectiveDateDesc = (a: { effectiveDate: string }, b: { effectiveDate: string }) => {
  if (a.effectiveDate < b.effectiveDate) {
    return 1;
  }

  if (a.effectiveDate > b.effectiveDate) {
    return -1;
  }
  return 0
}

export interface SortableItem {
  sortTitle?: string;
  unitCount?: number;
}

export interface SortType<T = SortableItem> { field: keyof T, asc: boolean }
export const Sort: { [key: string]: SortType } = {
  TitleAsc: {
    field: 'sortTitle',
    asc: true
  },
  TitleDesc: {
    field: 'sortTitle',
    asc: false
  },
  UnitCountAsc: {
    field: 'unitCount',
    asc: true
  },
  UnitCountDesc: {
    field: 'unitCount',
    asc: false
  }
}

export function sortItems<T = SortableItem>(cards: T[], sortType: SortType<T>) {
  const field = sortType.field;
  const newCards = cards.slice().sort((a, b) => naturalSort(String(a[field]), String(b[field])));

  if (sortType.asc) {
    return newCards;
  } else {
    return newCards.reverse();
  }
}

export function sortItemsByTypeCode<T extends ScopeQuestionOptionalValue = ScopeQuestionOptionalValue>(
  cards: T[],
  alternativeCode?: string
): T[] {
  const getTypeCode = (q: T, alternativeCode?: string) => {
    return q.universalTracker.getTypeCode(alternativeCode) || '';
  };
  return cards.slice().sort((a, b) => (
    naturalSort(getTypeCode(a, alternativeCode), getTypeCode(b, alternativeCode))
    ||
    naturalSort(a.name, b.name))
  );
}
